export const MOBILE_SETTINGS = '/mobile/settings/' as const
export const MOBILE_SETTINGS_VERSIONS = `${MOBILE_SETTINGS}versions` as const
